import Vue from "vue";

export async function getProductLines(params = {}) {
    const response = await Vue.prototype.$http.get("/product_lines", {
        params,
    });

    return response.data.data;
}